import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import settings from '@tenant/settings'
import { getFirstItem } from 'lib/util'
import Icon from 'ui/Element/Icon'
import Image from 'ui/Element/Image'

const styles = () => ({
  icon: {
    width: '3rem',
    minHeight: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Displays the icon of a person.
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellDashboardPersonIcon = (classes, props = {}) => (
  <Grid
    item
    xs={'auto'}
    className={classes.icon}
  >
    <Icon
      size={32}
      rounded={true}
      source={'user'}
      padding={'0.5rem'}
      background={'gray.960'}
    />
  </Grid>
)

export default CellHOC(ListItemCellDashboardPersonIcon, styles)
